import { render, staticRenderFns } from "./RadarChartComparative.vue?vue&type=template&id=4798850c&scoped=true&"
import script from "./RadarChartComparative.vue?vue&type=script&lang=ts&"
export * from "./RadarChartComparative.vue?vue&type=script&lang=ts&"
import style0 from "./RadarChartComparative.vue?vue&type=style&index=0&id=4798850c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4798850c",
  null
  
)

export default component.exports